<template>
  <div class="get_verify_code_box">
    <el-dialog v-dialogDragOnly :close-on-click-modal="false" custom-class="get_verify_code_dialog" width='380px' :title="$t(title)" append-to-body :visible="visible" :before-close="hideAdd">
      <div class="clearfix">
        <BaseInfo :option="option" :data="baseData" @save="sureAdd" @cancel="hideAdd" :submitting="submitting" ref="forget_password_diaog_ref" class="create-dialog" />
        <el-button @click="getVerifyCode" size="mini" style="margin-left: 5px;" class="get_verify_code_btn" :disabled="isAble">{{verify_code_text}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaseInfo from "~/common/components/detail/BaseInfo.vue";
import { mapState } from 'vuex';
export default {
  name: "GetVerifyCode",
  components: {
    BaseInfo
  },
  props: {
    title: {
      type: String,
      default: 'login.forget_password'
    },
    forgetPasswordData: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isAble: false,
      verify_code_text: this.$t('login.get_verification_code'),
      submitting: false,
      option: {
        field: [{
          type: 'readonly',
          name: 'tel',
          placeholder: this.$t('portal.lian-xi-xin-xi'),
          span: 24
        }, {
          type: 'text',
          name: 'verify_code',
          placeholder: this.$t('login.verification_code'),
          mark: this.$t('tip.please_enter'),
          span: 16
        }],
        rules: {
          verify_code: [{
            required: true,
            trigger: "blur",
            message: this.$t('validate.code')
          }]
        },
        isAdd: true,
        isEdit: true,
        isAddHtml: this.$t('button.submit')
      },
      baseData: {}
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.baseData = JSON.parse(JSON.stringify(this.forgetPasswordData));
      }
    }
  },
  created() {},
  computed: {
    ...mapState({
      userProfile: state => state.login.userProfile
    })
  },
  methods: {
    getVerifyCode() {
      if (!this.forgetPasswordData.tel) {
        this.$message.error(this.$t('portal.qing-xian-she-zhi-lian-xi-dian-hua'));
        return;
      }
      let _self = this;
      this.$axios.$post('/rest/store/hub/v3/nodeold/verifyCodeSend', {
        "mobile": this.forgetPasswordData.tel
      }).then(res => {
        if (res.code === 200) {
          let timer = 60;
          _self.isAble = true;
          let verify_code = setInterval(function () {
            timer--;
            if (timer == 0) {
              _self.verify_code_text = this.$t('portal.chong-xin-huo-qu-yan-zheng-ma');
              clearInterval(verify_code);
              _self.isAble = false;
              return;
            }
            _self.verify_code_text = this.$t('portal.sheng-yu') + timer + this.$t('portal.miao');
          }, 1000);
        }
      });
    },
    sureAdd(data) {
      // 请求接口成功，隐藏当前弹窗，弹出设置新密码弹窗
      this.submitting = true;
      this.$axios.$post('/rest/store/hub/v3/nodeold/verifyCodeCheck', {
        "mobile": this.forgetPasswordData.tel,
        "code": data.verify_code
      }).then(res => {
        this.submitting = false;
        if (res && res.code === 200) {
          this.hideAdd();
          this.$emit('next');
        }
      });
    },
    hideAdd() {
      this.$refs.forget_password_diaog_ref.resetField();
      this.$emit('hide');
    }
  }
};
</script>

<style lang="less">
.get_verify_code_dialog {
  .clearfix {
    position: relative;
    .el-form-item__content {
      height: 26px;
    }
    .get_verify_code_btn {
      position: absolute;
      top: 54px;
      left: calc(66.66667%);
      padding: 4px 10px;
      color: rgb(234, 87, 40);
    }
  }
}
</style>
